<template>
    <div>
        <Row :gutter="16">

            <Col span="24">
                <Card>
                    <p slot="title">
                        <Button to="/content/article/history/list" type="text" size="small" icon="md-arrow-back"></Button>
                        {{t.routerName}}
                    </p>
                    <Row>
                        <Form :model="formItem" :label-width="85" label-position="right">
                            <FormItem :label="t.article.releaseTime" prop="releaseTime">
                                <Input v-model="formItem.releaseTime" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.article.title" prop="title">
                                <Input v-model="formItem.title" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.article.author" prop="author">
                                <Input v-model="formItem.author" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.article.description" prop="description">
                                <Input v-model="formItem.description" type="textarea" :rows="2" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.article.body">
                                <tinymce id="id1" v-model="formItem.body" :toolbar1="toolbar1"
                                         :other_options="other_options" readonly></tinymce>
                            </FormItem>
                        </Form>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
    import { getArticleHistory } from '@/api/article';

    export default {
        name: 'content_article_history_detail',
        data() {
            const t = this.$_t();
            const msgUtil = this.$msgUtil;
            return {
                t: t,
                self: this,
                msgUtil: msgUtil,
                imageSizeList: [],
                curImage: null,
                formItem: {
                    title: '',
                    author: '',
                    description: '',
                    body: '',
                    hits: 0,
                    charge: '1',
                    status: '0',
                    disabled: '1',
                    releaseTime: '',
                },
                toolbar1: 'newnote print preview code',
                other_options: {
                    height: 500,
                    menubar: false,
                    plugins: 'image code print preview',
                },
                loading: false,
            };
        },
        beforeCreate() {
            import('tinymce-i18n/langs/ja');
        },
        beforeDestroy() {
            //console.log(this.$refs.tree);
        },
        async mounted() {
            //得到文章情报
            const articleInfo = await getArticleHistory(this.$route.params.id);
            if (articleInfo.articleHistory != null) {
                this.formItem = articleInfo.articleHistory;
                if (this.formItem.status === '0') {
                    this.formItem.status = this.t.article.status0;
                } else if (this.formItem.status === '1') {
                    this.formItem.status = this.t.article.status1;
                } else if (this.formItem.status === '2') {
                    this.formItem.status = this.t.article.status2;
                } else if (this.formItem.status === '9') {
                    this.formItem.status = this.t.article.status9;
                }

                if (this.formItem.charge === '0') {
                    this.formItem.charge = this.t.article.charge0;
                } else if (this.formItem.charge === '1') {
                    this.formItem.charge = this.t.article.charge1;
                }

                if (this.formItem.disabled === '0') {
                    this.formItem.disabled = this.t.article.yes;
                } else if (this.formItem.disabled === '1') {
                    this.formItem.disabled = this.t.article.no;
                }
            }
        },
    };
</script>
<style lang="less" scoped>
</style>
